import {Level} from "./level";
import Tilemap = Phaser.Tilemap;
import TilemapLayer = Phaser.TilemapLayer;
import Point = Phaser.Point;
import Tile = Phaser.Tile;
/**
 * Class is used to create and load levels
 */

export class LevelLoader {
    layer: TilemapLayer;
    map: Tilemap;
    levelList: Level[];
    currentLevel: number;
    currentLayer: number;
    won: boolean;
    layerIndicator: any;

    constructor(private game: Phaser.Game) {
        this.levelList = [
            {
                // DUMMYLEVEL IS NOT USED BUT MAKES THINGS EASIER
                // DO NOT DELETE!!
                lvlnr: 0,
                startlayer: 0,
                endlayer: 0,
                start: new Point(1, 7)
            },
            {
                lvlnr: 1,
                startlayer: 0,
                endlayer: 0,
                start: new Point(1, 7)
            },
            {
                lvlnr: 2,
                startlayer: 0,
                endlayer: 1,
                start: new Point(5, 2)
            },
            {
                lvlnr: 3,
                startlayer: 0,
                endlayer: 2,
                start: new Point(4, 5)
            },
            {
                lvlnr: 4,
                startlayer: 0,
                endlayer: 2,
                start: new Point(7, 7)
            },
            {
                lvlnr: 5,
                startlayer: 0,
                endlayer: 3,
                start: new Point(3, 7)
            },
            {
                lvlnr: 6,
                startlayer: 0,
                endlayer: 3,
                start: new Point(5, 5)
            },
            {
                lvlnr: 7,
                startlayer: 0,
                endlayer: 3,
                start: new Point(1, 7)
            },
            {
                lvlnr: 8,
                startlayer: 0,
                endlayer: 3,
                start: new Point(3, 2)
            },
            {
                lvlnr: 9,//13,
                startlayer: 0,
                endlayer: 3,
                start: new Point(7, 1)
            },
            {
                lvlnr: 10,//14,
                startlayer: 0,
                endlayer: 2,
                start: new Point(7, 1)
            },
            {
                lvlnr: 11,//15,
                startlayer: 0,
                endlayer: 2,
                start: new Point(3, 4)
            },
            {
                lvlnr: 12,//9,
                startlayer: 0,
                endlayer: 3,
                start: new Point(1, 7)
            },
            {
                lvlnr: 13,//10,
                startlayer: 0,
                endlayer: 2,
                start: new Point(3, 3)
            },
            {
                lvlnr: 14,//11,
                startlayer: 0,
                endlayer: 3,
                start: new Point(0, 7)
            },
            {
                lvlnr: 15,//12,
                startlayer: 0,
                endlayer: 3,
                start: new Point(1, 1)
            },
        ]
    }

    initGridTiles() {
        this.game.load.image('gridtiles', 'assets/images/gridtiles_final.png');
        console.log("gridtiles loaded");
    }

    initLevels() {
        console.log("loading levels");
        for(let i = 1; i <= 15; i++) {
            this.game.load.tilemap('level' + i, 'assets/maps/level' + i + '.json', null, Phaser.Tilemap.TILED_JSON);
        }
        this.currentLevel = 0;
    }

    loadLevel(level: number) {
        this.map = this.game.add.tilemap('level' + level);
        this.map.addTilesetImage('gridtiles');
        this.currentLevel = level;
    }

    // Loads a layer into the map
    loadLayer(layer: number) {
        let layername = 'layer' + layer;
        this.currentLayer = layer;
        this.layer = this.map.createLayer(layername);

        // SET POSITION AND SIZE OF MAP
        this.layer.scale.set(1.5);
        this.layer.fixedToCamera = false;
        this.layer.scrollFactorX = 0;
        this.layer.scrollFactorY = 0;
        this.layer.position.set(this.game.width/2 -190, 90);

        this.layer.resizeWorld();

        // RENDER CURRENT LAYER
        let layerIcon: string = String(this.levelList[this.currentLevel].endlayer) + String(this.currentLayer);
        this.layerIndicator = this.game.add.sprite(this.game.width/2 -100, 555, layerIcon);//.scale.set(0.85);
    }

    switchTiles(source: Tile, target: Tile, targetLayer: number) {
        // Temporary index saves the color of the target tile before replacing it
        let tempIndex = target.index;

        // Remove door or key tile
        if(target.index === 3 || target.index === 7) {
            // Replace target tile with source
            this.map.swap(target.index, source.index, target.x, target.y, 1, 1, targetLayer);
            // Replace source tile with ground tile
            this.map.swap(source.index, 1, source.x, source.y, 1, 1, this.currentLayer);
        }
        // Else swap tiles
        else {
            // Replace target tile with source
            this.map.swap(target.index, source.index, target.x, target.y, 1, 1, targetLayer);

            // Replace source tile with target
            this.map.swap(source.index, tempIndex, source.x, source.y, 1, 1, this.currentLayer);
        }

        // Should actually be updated by phaser automatatically but does not
        this.layer.dirty = true;

        // If the layer has changed the new layer is loaded
        if (this.currentLayer !== targetLayer) {
            this.layer.destroy();
            this.layerIndicator.destroy();
            this.loadLayer(targetLayer);
        }
    }

    // Returns tile at Postion x, y, layer
    getTile(x, y, layer) {
        // Check if target tile is inside the borders of the map
        if (this.notInBoarders(x, y, layer))
            return null;
        else
            return this.map.getTile(x, y, layer);
    }

    notInBoarders(x, y, layer) {
        if (this.won) {
            this.won = false;
            // Don't check level boarders if player has just won
            return x < 0 || y < 0 || layer < 0 ||
                x >= this.map.width || y >= this.map.height;
        }
        return x < 0 || y < 0 || layer < 0 ||
            x >= this.map.width || y >= this.map.height ||
            this.levelList[this.currentLevel].startlayer > layer || this.levelList[this.currentLevel].endlayer < layer;
    }
}


// WEBPACK FOOTER //
// ./src/levelloader.ts